module.exports = __webpack_public_path__ + "static/media/Covid19-2.0b43c73a.webp";